import { RefCategorie } from './ref-categorie.model';
import { DataIdConverterFactory } from 'src/app/core/services/mapper/data-id.converter';
import { RefTypeBalise } from './ref-type-balise.model';
import { ArrayClassConverterFactory, ClassConverterFactory } from 'src/app/core/services/mapper/data-property.converter';

export class Balise {
    static jsonMap = {
        id: { key: 'id', optional: true },
        code: { key: 'code', optional: true, default: '' },
        libelle: { key: 'libelle', optional: true, default: '' },
        html: { key: 'html', optional: true, default: '' },
        contenu: { key: 'contenu', optional: true, default: '' },
        refCategorie: { key: 'idRefCategorie', converter: new (DataIdConverterFactory.build(RefCategorie, 'refCategorieList'))(), optional: true },
        idBaliseParent: { key: 'idBaliseParent', optional: true },
        baliseParent: { key: 'baliseParent', converter: new (ClassConverterFactory.build(Balise))(), optional: true },
        refTypeBalise: { key: 'idRefTypeBalise', converter: new (DataIdConverterFactory.build(RefTypeBalise, 'refTypeBaliseList'))(), optional: true },
        childrens: { key: 'childrens', converter: new (ArrayClassConverterFactory.build(Balise))(), optional: true, default: () => [] }
    };

    id: number;
    code: string;
    libelle: string;
    html: string;
    contenu: string;
    refCategorie: RefCategorie;
    idBaliseParent: number;
    baliseParent: Balise;
    refTypeBalise: RefTypeBalise;
    childrens?: Balise[];
}
